import React from "react";
import {
  Page,
  Navbar,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  ListItemCell,
  Icon,
  Button,
  Row,
  Col,
  Popup,
  Preloader,
  TextEditor,
  Checkbox,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Range,
} from "framework7-react";

import {
  PrimaryLogo,
  MerchantSvg,
  BikeSvg,
  WalletSvg,
} from "../components/crumbs";

import moment from "moment";
import * as geofire from "geofire-common";

// Redux
import { compose } from "redux";
import { connect } from "react-redux";
import { getDistance } from "geolib";
import { withFirestore, firestoreConnect } from "../HOCs";
import {
  toast,
  handleErrors,
  sendEasychawOneTimePassword,
  verifyEasychawOneTimePassword,
} from "../utils/_helpers";
import {
  Collections,
  FilterByText,
  FilterByNumber,
  FilterBySelect,
} from "../utils/_classes";

class Support extends React.Component {
  constructor() {
    super();

    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: "",
        which: "",
      },

      nearestBranches: [],

      //used for range of delivery agents
      deliveryAgentsRange: 15,

      //used for loading delivery agents
      vendorSheetOpened: false,

      // sales single order detail
      salesOrderDetails: null,

      // state for form fields reset
      transactionId: "",
      orderId: "",
      orderStatus: "",
      merchantName: "",
      deliveryAgentName: "",
      deliveryAgentEmail: "",

      // Data state
      orders: [],
      deliveryAgents: [],

      filterBy: {
        dbName: "",
        property: "",
        value: "",
        type: "",
      },
    };
  }

  render() {
    return (
      <Page>
        <Navbar sliding={false} backLink="Back">
          <NavTitle sliding> Sales Support Dashboard</NavTitle>
        </Navbar>

        <Block>
          <Row>
            {/* All Sales Card */}
            <Col width="100">
              <Card
                className="data-table data-table-init"
                style={{
                  width: "100%",
                  marginLeft: "0px",
                  maxHeight: "700px",
                }}
              >
                <CardHeader>
                  <div className="data-table-title">All Sales</div>
                </CardHeader>
                {this.props.ordered.orders ? (
                  <CardContent
                    padding={false}
                    style={{
                      width: "100%",
                      maxHeight: "600px",
                      overflow: "scroll",
                    }}
                  >
                    <table className="sticky">
                      <thead>
                        <tr>
                          <th>
                            <span className="table-head-label">SNo.</span>
                          </th>
                          <th className="input-cell">
                            <span className="table-head-label">Order ID</span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.orderId}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    transactionId: "",
                                    orderId: e.target.value,

                                    orderStatus: "",
                                    merchantName: "",
                                    filterBy: {
                                      dbName: "orders",
                                      property: "id",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th className="input-cell">
                            <span className="table-head-label">
                              Order Status
                            </span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.orderStatus}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    transactionId: "",
                                    orderId: "",
                                    orderStatus: e.target.value,

                                    merchantName: "",
                                    filterBy: {
                                      dbName: "orders",
                                      property: "orderStatus",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th className="input-cell">
                            <span className="table-head-label">
                              Transaction ID
                            </span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.transactionId}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    transactionId: e.target.value,
                                    orderId: "",
                                    orderStatus: "",
                                    merchantName: "",
                                    filterBy: {
                                      dbName: "orders",
                                      property: "reference",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>

                          <th className="input-cell">
                            <span className="table-head-label">
                              Merchant Name
                            </span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.merchantName}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    transactionId: "",
                                    orderId: "",
                                    orderStatus: "",
                                    merchantName: e.target.value,
                                    filterBy: {
                                      dbName: "orders",
                                      property: "merchantName",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th>
                            <span className="table-head-label">Timestamp</span>
                          </th>
                          <th>
                            <span className="table-head-label">Action</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.orders
                          .sort(
                            (a, b) =>
                              +moment(b.timestamp) - +moment(a.timestamp),
                          )
                          .sort((a, b) => {
                            if (a.orderStatus === "Order Cancelled") {
                              if (b.orderStatus === "Order Completed")
                                return -1;
                              if (
                                b.orderStatus === "Order Pending" ||
                                b.orderStatus === "Order Pending Delivery" ||
                                b.orderStatus === "Order Pending Confirmation"
                              )
                                return 1;
                              return 0;
                            }

                            if (a.orderStatus === "Order Pending Delivery") {
                              if (
                                b.orderStatus === "Order Cancelled" ||
                                b.orderStatus ===
                                  "Order Pending Confirmation" ||
                                b.orderStatus === "Order Completed"
                              )
                                return -1;
                              if (b.orderStatus === "Order Pending") return 1;
                              return 0;
                            }

                            if (
                              a.orderStatus === "Order Pending Confirmation"
                            ) {
                              if (
                                b.orderStatus === "Order Cancelled" ||
                                b.orderStatus === "Order Completed"
                              )
                                return -1;
                              if (
                                b.orderStatus === "Order Pending" ||
                                b.orderStatus === "Order Pending Confirmation"
                              )
                                return 1;
                              return 0;
                            }

                            if (a.orderStatus === "Order Pending") {
                              if (
                                b.orderStatus === "Order Cancelled" ||
                                b.orderStatus === "Order Pending Delivery" ||
                                b.orderStatus ===
                                  "Order Pending Confirmation" ||
                                b.orderStatus === "Order Completed"
                              )
                                return -1;
                              return 0;
                            }

                            if (a.orderStatus === "Order Completed") {
                              if (
                                b.orderStatus === "Order Cancelled" ||
                                b.orderStatus === "Order Pending Delivery" ||
                                b.orderStatus ===
                                  "Order Pending Confirmation" ||
                                b.orderStatus === "Order Pending"
                              )
                                return 1;
                              return 0;
                            }
                          })
                          .map((order, i) => (
                            <tr key={order.id}>
                              <td
                                className={
                                  order.orderStatus == "Order Pending"
                                    ? "signal-pending"
                                    : order.orderStatus == "Order Completed"
                                    ? "signal-complete"
                                    : order.orderStatus == "Order Cancelled"
                                    ? "signal-cancelled"
                                    : "signal-default"
                                }
                              >
                                <div>{i + 1}</div>
                              </td>
                              <td>
                                <div>{order.id}</div>
                              </td>
                              <td>
                                <div>{order.orderStatus}</div>
                              </td>
                              <td>
                                <div>{order.reference}</div>
                              </td>
                              <td>
                                <div>{order.merchantName}</div>
                              </td>
                              <td>
                                <div>{moment(order.timestamp).fromNow()}</div>
                              </td>
                              <td>
                                <Button
                                  fill
                                  onClick={() => {
                                    this.setState({
                                      ...this.state,
                                      popupOpened: true,
                                      popupDataChanged: true,
                                      popupData: {
                                        title: "Sale Order",
                                        which: "sales",
                                      },
                                      salesOrderDetails: order,
                                    });
                                  }}
                                >
                                  Details
                                </Button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </CardContent>
                ) : (
                  <CardContent padding={false}>
                    <Block className="block-info">
                      <Row>
                        <Col>
                          <p>No sales transactions available at the moment!</p>
                        </Col>
                      </Row>
                    </Block>
                  </CardContent>
                )}
              </Card>
            </Col>

            {/* Sales Chart Card */}
            <Col width="100">
              <Card
                className="data-table data-table-init"
                style={{
                  width: "100%",
                  marginLeft: "0px",
                  marginBottom: "80px",
                }}
              >
                <CardHeader>
                  <div className="data-table-title">Sales Chart</div>
                </CardHeader>
                <CardContent padding={false}>
                  <Block className="pab">
                    <Row>
                      <Col>
                        <p>Future Update: Sales Chart Coming Soon!</p>
                      </Col>
                    </Row>
                  </Block>
                </CardContent>
              </Card>
            </Col>
          </Row>
        </Block>

        <Popup
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() =>
            this.setState({
              ...this.state,
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: "", which: "" },
              vendor: null,
              nearestBranches: [],
              vendorSheetOpened: false,
            })
          }
          onPopupOpened={(e) => e.app.methods.showFullText()}
        >
          <Page>
            <Navbar title={this.state.popupData.title}>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            {/* Content for viewing sale order */}
            {this.state.popupData.which == "sales" ? (
              <Block style={{ margin: "auto" }}>
                {/* [Card-1] Order Items */}
                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader
                    className={`
                      no-border
                      bg-image-pattern no-padding
                      ${
                        this.props.data.orders[this.state.salesOrderDetails.id]
                          .orderStatus === "Order Pending"
                          ? "bg-color-bisque"
                          : this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].orderStatus === "Order Pending Confirmation"
                          ? "bg-color-oldlace"
                          : this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].orderStatus === "Order Completed"
                          ? "bg-color-teagreen"
                          : this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].orderStatus === "Order Pending Delivery"
                          ? "bg-color-cultured"
                          : "bg-color-pink"
                      }
                    `}
                    style={{
                      backgroundSize:
                        parseInt(window.innerWidth) < 700 ? "50%" : "30%",
                      height: "200px",
                    }}
                  >
                    {this.props.data.orders[this.state.salesOrderDetails.id]
                      .orderStatus === "Order Pending Confirmation" ? (
                      <BikeSvg height="200px" style={{ margin: "auto" }} />
                    ) : this.props.data.orders[this.state.salesOrderDetails.id]
                        .orderStatus === "Order Completed" ? (
                      <img
                        src="static/confirmed.svg"
                        style={{ margin: "auto", width: "200px" }}
                      />
                    ) : this.props.data.orders[this.state.salesOrderDetails.id]
                        .orderStatus === "Order Pending" ? (
                      <img
                        src="static/relax.svg"
                        style={{ margin: "auto", width: "200px" }}
                      />
                    ) : this.props.data.orders[this.state.salesOrderDetails.id]
                        .orderStatus === "Order Pending Delivery" ? (
                      <img
                        src="static/delivery.svg"
                        style={{ margin: "auto", width: "200px" }}
                      />
                    ) : (
                      <img
                        src="static/cancel.svg"
                        style={{ margin: "auto", width: "200px" }}
                      />
                    )}
                  </CardHeader>
                  <CardFooter>
                    <strong
                      className={`
                        ${
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus === "Order Pending Confirmation" ||
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus === "Order Pending Delivery"
                            ? "color-bluejeans"
                            : this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].orderStatus === "Order Completed"
                            ? "color-forestgreen"
                            : this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].orderStatus === "Order Pending"
                            ? "color-yelloworange"
                            : "color-tart"
                        }
                      `}
                    >
                      {this.props.data.orders[this.state.salesOrderDetails.id]
                        .orderStatus === "Order Cancelled"
                        ? "Declined"
                        : true === "Order Pending Confirmation"
                        ? "Enroute"
                        : this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus}
                    </strong>
                    <Button
                      outline
                      iconF7="doc_on_clipboard"
                      onClick={(e) => this.$f7.methods.copyText(e, "Order Id")}
                    >
                      &nbsp;&nbsp;&nbsp;Order Id:
                      <span className="copytext">
                        {this.state.salesOrderDetails.id}
                      </span>
                    </Button>
                  </CardFooter>
                </Card>

                <Card
                  className="easyPrintText"
                  style={{ margin: "auto", marginTop: "10pt" }}
                >
                  <CardHeader>Order Items</CardHeader>
                  <CardContent>
                    <List>
                      {/* Load packages */}
                      {this.props.data.orders[
                        this.state.salesOrderDetails.id
                      ].packages.map((product, i) => (
                        <ListItem key={i}>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <span style={{ display: "inline-flex" }}>
                              {product.count} &nbsp;x&nbsp;&nbsp;
                            </span>
                          </ListItemCell>
                          <ListItemCell
                            className="flex-shrink-3"
                            style={{ marginLeft: 0 }}
                          >
                            <div className="row">
                              <p className="col">{product.name}</p>
                            </div>
                          </ListItemCell>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <h6>
                              {new Intl.NumberFormat("en-GB", {
                                style: "currency",
                                currency: "NGN",
                              }).format(product.amount)}
                            </h6>
                          </ListItemCell>
                        </ListItem>
                      ))}
                    </List>

                    <List>
                      <ListItem>
                        <ListItemCell
                          className="flex-shrink-3"
                          style={{ marginLeft: 0 }}
                        >
                          <div className="row">
                            <p className="col">
                              {this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].userDeliveryCharge > 0
                                ? "Delivery Charge"
                                : "Pickup Charge"}
                            </p>
                          </div>
                        </ListItemCell>
                        <ListItemCell className="width-auto flex-shrink-0">
                          <h6>
                            {new Intl.NumberFormat("en-GB", {
                              style: "currency",
                              currency: "NGN",
                            }).format(
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].userDeliveryCharge,
                            )}
                          </h6>
                        </ListItemCell>
                      </ListItem>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      outline
                      iconF7="doc_on_clipboard"
                      onClick={(e) =>
                        this.$f7.methods.copyText(e, "Confirmation Code")
                      }
                    >
                      &nbsp;&nbsp;&nbsp;Confirmation Code:
                      <span className="copytext">
                        {this.state.salesOrderDetails.confirmationCode}
                      </span>
                    </Button>

                    <Button outline disabled>
                      {new Intl.NumberFormat("en-GB", {
                        style: "currency",
                        currency: "NGN",
                      }).format(
                        parseInt(this.state.salesOrderDetails.totalUserAmount) +
                          parseInt(
                            this.state.salesOrderDetails.userDeliveryCharge,
                          ),
                      )}
                    </Button>
                  </CardFooter>
                </Card>

                {/* [Card-2] User Details */}
                <Card style={{ margin: "10pt auto" }}>
                  <CardHeader className="no-border">User Details</CardHeader>

                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].fullName
                        }
                        after="Client Name"
                      >
                        <Icon f7="person_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].deliveryAddress
                        }
                        after="Client Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].phoneNumber
                        }
                        after="Client Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>

                  <CardFooter>
                    <Button
                      outline
                      style={{ width: "45%" }}
                      popupClose
                      href={`tel://${
                        this.props.data.orders[this.state.salesOrderDetails.id]
                          .phoneNumber
                      }`}
                      external
                      onClick={() =>
                        this.$f7.methods.phoneCall(
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].phoneNumber,
                        )
                      }
                    >
                      <Icon f7="phone_fill_arrow_up_right" />{" "}
                      &nbsp;&nbsp;&nbsp;Call User
                    </Button>

                    <Button
                      outline
                      style={{ width: "45%" }}
                      onClick={() => this.$f7.methods.navMessage()}
                    >
                      <Icon f7="bubble_left_bubble_right" />
                      &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                    </Button>
                  </CardFooter>
                </Card>

                {/* [Card-3] Post Dated Details */}
                <Card style={{ margin: "10pt auto" }}>
                  <CardHeader className="no-border">
                    Post Dated Details
                  </CardHeader>
                  {this.props.data.orders[this.state.salesOrderDetails.id]
                    .postDatedInstructions ? (
                    <CardContent>
                      <List>
                        <ListItem
                          title={
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].postDatedDate
                              ? moment(
                                  this.props.data.orders[
                                    this.state.salesOrderDetails.id
                                  ].postDatedDate,
                                ).format("dddd, MMMM Do, YYYY | hh:mm")
                              : ""
                          }
                          after="Date | Time"
                        >
                          <Icon f7="info_circle_fill" slot="media" />
                        </ListItem>

                        <ListItem
                          className="show-text"
                          title={
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].postDatedInstructions
                              ? this.state.salesOrderDetails
                                  .postDatedInstructions
                              : ""
                          }
                          after="Instructions"
                        >
                          <Icon f7="info_circle_fill" slot="media" />
                        </ListItem>
                      </List>
                    </CardContent>
                  ) : (
                    <CardContent style={{ paddingTop: 0 }}>
                      <Block className="block-info">
                        <Row>
                          <Col>
                            <p>No Post Dated Order Details</p>
                          </Col>
                        </Row>
                      </Block>
                    </CardContent>
                  )}
                </Card>

                {/* [Card-4] Merchant Details */}
                <Card style={{ margin: "10pt auto" }}>
                  <CardHeader className="no-border">
                    Merchant Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].merchantName
                        }
                        after="Merchant Name"
                      >
                        <Icon f7="briefcase" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={
                          this.props.ordered.merchants.find(
                            ({ id }) =>
                              id ===
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].merchantId,
                          ).businessProfile.address
                        }
                        after="Merchant Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={
                          this.props.ordered.merchants.find(
                            ({ id }) =>
                              id ===
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].merchantId,
                          ).businessProfile.phone
                        }
                        after="Merchant Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      outline
                      style={{ width: "45%" }}
                      popupClose
                      href={`tel://${
                        this.props.ordered.merchants.find(
                          ({ id }) =>
                            id ===
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].merchantId,
                        ).businessProfile.phone
                      }`}
                      external
                      onClick={() =>
                        this.$f7.methods.phoneCall(
                          this.props.ordered.merchants.find(
                            ({ id }) =>
                              id ===
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].merchantId,
                          ).businessProfile.phone,
                        )
                      }
                    >
                      <Icon f7="phone_fill_arrow_up_right" />{" "}
                      &nbsp;&nbsp;&nbsp;Call Merchant
                    </Button>
                    <Button
                      outline
                      style={{ width: "45%" }}
                      onClick={() => this.$f7.methods.navMessage()}
                    >
                      <Icon f7="bubble_left_bubble_right" />
                      &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                    </Button>
                  </CardFooter>
                </Card>

                {/* [Card-5] Delivery Agent Details */}
                <Card style={{ margin: "10pt auto" }}>
                  {this.props.data.orders[this.state.salesOrderDetails.id]
                    .deliveryRequired ? (
                    <>
                      <CardHeader className="no-border">
                        Assigned Delivery Agent
                      </CardHeader>

                      {this.props.data.orders[this.state.salesOrderDetails.id]
                        .assignedAgentId &&
                      this.props.data.orders[this.state.salesOrderDetails.id]
                        .assignedAgentId !== "" ? (
                        <>
                          <CardContent>
                            <List>
                              <ListItem
                                className="show-text"
                                title={
                                  this.props.data.delivery[
                                    this.state.salesOrderDetails.assignedAgentId
                                  ].businessProfile.name
                                }
                                after="Agent Name"
                              >
                                <Icon f7="briefcase" slot="media" />
                              </ListItem>
                              <ListItem
                                className="show-text"
                                title={
                                  this.props.data.delivery[
                                    this.props.data.orders[
                                      this.state.salesOrderDetails.id
                                    ].assignedAgentId
                                  ].businessProfile.address
                                }
                                after="Agent Address"
                              >
                                <Icon f7="placemark_fill" slot="media" />
                              </ListItem>
                              <ListItem
                                title={
                                  this.props.data.delivery[
                                    this.props.data.orders[
                                      this.state.salesOrderDetails.id
                                    ].assignedAgentId
                                  ].businessProfile.phone
                                }
                                after="Agent Phone"
                              >
                                <Icon
                                  f7="phone_fill_arrow_up_right"
                                  slot="media"
                                />
                              </ListItem>

                              {this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].agent?.branch ? (
                                <List>
                                  <ListItem
                                    className="show-text"
                                    after="Branch Name"
                                  >
                                    <span slot="title">
                                      {
                                        this.props.data.orders[
                                          this.state.salesOrderDetails.id
                                        ].agent?.branch?.name
                                      }
                                    </span>
                                    <Icon f7="arrow_branch" slot="media" />
                                  </ListItem>
                                  <ListItem
                                    className="show-text"
                                    after="Branch Address"
                                  >
                                    <span slot="title">
                                      {
                                        this.props.data.orders[
                                          this.state.salesOrderDetails.id
                                        ].agent?.branch?.address
                                      }
                                    </span>
                                    <Icon f7="placemark_fill" slot="media" />
                                  </ListItem>
                                  <ListItem after="Branch Phone">
                                    <span slot="title">
                                      {
                                        this.props.data.orders[
                                          this.state.salesOrderDetails.id
                                        ].agent?.branch?.phone
                                      }
                                    </span>
                                    <Icon
                                      f7="phone_fill_arrow_up_right"
                                      slot="media"
                                    />
                                  </ListItem>
                                </List>
                              ) : null}
                            </List>
                          </CardContent>

                          <CardFooter>
                            <Button
                              outline
                              style={{
                                width: this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].agent?.branch
                                  ? "30%"
                                  : "45%",
                              }}
                              popupClose
                              href={`tel://${
                                this.props.data.delivery[
                                  this.props.data.orders[
                                    this.state.salesOrderDetails.id
                                  ].assignedAgentId
                                ].businessProfile.phone
                              }`}
                              external
                              onClick={() =>
                                this.$f7.methods.phoneCall(
                                  this.props.data.delivery[
                                    this.props.data.orders[
                                      this.state.salesOrderDetails.id
                                    ].assignedAgentId
                                  ].businessProfile.phone,
                                )
                              }
                            >
                              <Icon f7="phone_fill_arrow_up_right" />{" "}
                              &nbsp;&nbsp;&nbsp;Call Delivery
                            </Button>

                            {this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].agent?.branch ? (
                              <Button
                                outline
                                style={{ width: "30%" }}
                                href={`tel://${
                                  this.props.data.orders[
                                    this.state.salesOrderDetails.id
                                  ].agent?.branch?.phone
                                }`}
                                external
                                onClick={() =>
                                  this.$f7.methods.phoneCall(
                                    this.props.data.orders[
                                      this.state.salesOrderDetails.id
                                    ].agent?.branch?.phone,
                                  )
                                }
                              >
                                <Icon f7="phone_fill_arrow_up_right" />
                                &nbsp;&nbsp;&nbsp;Call Delivery Branch
                              </Button>
                            ) : null}

                            <Button
                              outline
                              style={{
                                width: this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].agent?.branch
                                  ? "30%"
                                  : "45%",
                              }}
                              onClick={() => this.$f7.methods.navMessage()}
                            >
                              <Icon f7="bubble_left_bubble_right" />
                              &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                            </Button>
                          </CardFooter>
                        </>
                      ) : (
                        <CardContent style={{ paddingTop: 0 }}>
                          <Block className="block-info">
                            <Row>
                              <Col>
                                <p>No Delivery Agent Details</p>
                              </Col>
                            </Row>
                          </Block>
                        </CardContent>
                      )}
                    </>
                  ) : (
                    <>
                      <CardHeader className="no-border">
                        Pickup Order
                      </CardHeader>
                      <CardContent style={{ paddingTop: 0 }}>
                        <Block className="block-info">
                          <Row>
                            <Col>
                              <p>
                                This package is designated for pickup from
                                merchant, no delivery details required.
                              </p>
                            </Col>
                          </Row>
                        </Block>
                      </CardContent>
                    </>
                  )}
                </Card>

                {/* [Card-6] User Issue Report */}
                {this.props.data.orders[this.state.salesOrderDetails.id]
                  .reportMerchant ? (
                  <Card
                    className="easyPrintText"
                    style={{ margin: "10pt auto" }}
                  >
                    <CardHeader className="no-border">
                      User Report
                      <Icon
                        f7="exclamationmark_triangle_fill"
                        style={{ color: "#E02020" }}
                      />
                    </CardHeader>
                    <CardContent>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].reportMerchant.issue,
                        }}
                      ></div>
                    </CardContent>
                    <CardFooter>
                      <pre>
                        <small>
                          Reported:{" "}
                          {this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].reportMerchant.timestamp &&
                            moment(
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].reportMerchant.timestamp,
                            ).format("dddd, MMMM Do, YYYY | hh:mm")}
                        </small>
                      </pre>
                    </CardFooter>
                  </Card>
                ) : null}

                {/* [Card-7] Delivery Agent Issue Report */}
                {this.props.data.orders[this.state.salesOrderDetails.id]
                  .issue ? (
                  <Card
                    className="easyPrintText"
                    style={{ margin: "10pt auto" }}
                  >
                    <CardHeader className="no-border">
                      Delivery Agent Report
                      <Icon
                        f7="exclamationmark_triangle_fill"
                        style={{ color: "#E02020" }}
                      />
                    </CardHeader>
                    <CardContent>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].issue,
                        }}
                      ></div>
                    </CardContent>
                    <CardFooter>
                      <pre>
                        <small>
                          Reported:{" "}
                          {this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].issueTimestamp &&
                            moment(
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].issueTimestamp,
                            ).format("dddd, MMMM Do, YYYY | hh:mm")}
                        </small>
                      </pre>
                    </CardFooter>
                  </Card>
                ) : null}

                {/* [Card-8] Admistrative Actions */}

                {(this.props.data.orders[this.state.salesOrderDetails.id]
                  .completed &&
                  this.props.data.orders[this.state.salesOrderDetails.id]
                    .orderStatus === "Order Completed") ||
                this.props.data.orders[this.state.salesOrderDetails.id]
                  .orderStatus === "Order Cancelled" ? null : (
                  <Card
                    style={{ margin: "10pt auto" }}
                    className="data-table data-table-init"
                  >
                    <CardHeader>
                      <div className="data-table-title">Admin Actions</div>
                    </CardHeader>
                    <CardContent padding={false}>
                      <table>
                        <thead>
                          <tr>
                            <th>
                              <span className="table-head-label">SNo.</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Action Description
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">Action</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus === "Order Pending" &&
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].deliveryRequired &&
                          !this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].deliveryInclusive ? (
                            <tr>
                              <td>*</td>
                              <td>
                                <div>Assign delivery agent</div>
                              </td>
                              <td>
                                <Button
                                  fill
                                  onClick={async () => {
                                    await this.getNearestBranches();
                                    this.setState({
                                      ...this.state,
                                      vendorSheetOpened: true,
                                    });
                                  }}
                                >
                                  Delivery Agent
                                </Button>
                              </td>
                            </tr>
                          ) : null}

                          <tr>
                            <td>*</td>
                            <td>
                              <div>
                                Confirm order on behalf of{" "}
                                {this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].deliveryRequired &&
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].orderStatus !== "Order Pending"
                                  ? "delivery agent"
                                  : "merchant"}
                              </div>
                            </td>
                            <td>
                              <Button
                                fill
                                className="button-fill-blue"
                                onClick={() =>
                                  this.confirmOrder(
                                    this.state.salesOrderDetails.id,
                                    this.state.salesOrderDetails
                                      .confirmationCode,
                                  )
                                }
                              >
                                Confirm Order
                              </Button>
                            </td>
                          </tr>

                          {this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus === "Order Pending Confirmation" ||
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus === "Order Pending Delivery" ? (
                            <tr>
                              <td>*</td>
                              <td>
                                <div>
                                  Decline order on behalf of delivery agent
                                </div>
                              </td>
                              <td>
                                <Button
                                  fill
                                  className="button-fill-red"
                                  onClick={() =>
                                    this.declineOrderForDeliveryAgent(
                                      this.state.salesOrderDetails.id,
                                      `${
                                        this.props.data.orders[
                                          this.state.salesOrderDetails.id
                                        ].agent.name
                                      } ${
                                        this.props.data.orders[
                                          this.state.salesOrderDetails.id
                                        ].agent.branch?.name || ""
                                      }`,
                                    )
                                  }
                                >
                                  Decline Order
                                </Button>
                              </td>
                            </tr>
                          ) : null}

                          {this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus === "Order Pending" ? (
                            <tr>
                              <td>*</td>
                              <td>
                                <div>Decline order on behalf of merchant</div>
                              </td>
                              <td>
                                <Button
                                  fill
                                  className="button-fill-red"
                                  onClick={() =>
                                    this.declineOrder(
                                      this.state.salesOrderDetails.id,
                                    )
                                  }
                                >
                                  Decline Order
                                </Button>
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </CardContent>
                  </Card>
                )}

                {/* [Sheet Modal] Delivery Agents Loader */}
                {this.state.vendorSheetOpened ? (
                  <div
                    style={{
                      margin: "auto",
                      width: "100%",
                      height: "50vh",
                      position: "fixed",
                      left: 0,
                      bottom: 0,
                      backgroundColor: "#f3f3f3",
                      zIndex: "15",
                    }}
                  >
                    {/* Modal Navbar */}
                    <div
                      className="display-flex justify-content-space-between align-items-center"
                      style={{
                        width: "100%",
                        height: "40px",
                        color: "rgba(22, 22, 22, 0.8)",
                        backgroundColor: "#fed448",
                      }}
                    >
                      <div style={{ fontSize: "12px", marginLeft: "16px" }}>
                        <b>Assign Delivery Agent</b>
                      </div>
                      <div
                        style={{ fontSize: "10px", marginRight: "16px" }}
                        onClick={() => {
                          this.setState({
                            ...this.state,
                            nearestBranches: [],
                            vendorSheetOpened: false,
                            deliveryAgentName: "",
                            deliveryAgentEmail: "",
                          });
                        }}
                      >
                        Close
                      </div>
                    </div>

                    {/* Modal Content */}
                    <Card
                      className="data-table data-table-init"
                      style={{
                        marginLeft: "16px",
                        marginRight: "16px",
                      }}
                    >
                      <CardHeader
                        className="no-border"
                        style={{ paddingRight: 0 }}
                      >
                        <div className="data-table-title">Delivery Agents</div>

                        <div style={{ width: "50%" }}>
                          <List simpleList style={{ width: "100%" }}>
                            <ListItem>
                              <ListItemCell className="width-auto flex-shrink-0">
                                <Icon f7="car_fill"></Icon>
                              </ListItemCell>
                              <ListItemCell className="flex-shrink-3">
                                <Range
                                  value={this.state.deliveryAgentsRange}
                                  step={5}
                                  min={0}
                                  max={100}
                                  label={true}
                                  onRangeChange={(e) => {
                                    this.setState({
                                      ...this.state,
                                      deliveryAgentsRange: e,
                                    });
                                  }}
                                ></Range>
                              </ListItemCell>
                              <ListItemCell className="width-auto flex-shrink-0">
                                <h6>
                                  <span>{this.state.deliveryAgentsRange}</span>
                                  km
                                </h6>
                              </ListItemCell>
                            </ListItem>
                          </List>
                        </div>
                      </CardHeader>
                      <CardContent
                        padding={false}
                        style={{ width: "100%", maxHeight: "300px" }}
                      >
                        {/* find delivery agent within 15km */}
                        {this.props.ordered.delivery &&
                        this.state.deliveryAgents.filter(
                          (agent) =>
                            agent.currentStatus === "online" &&
                            agent.accountStatus === "Approved" &&
                            getDistance(
                              this.props.data.merchants[
                                this.state.salesOrderDetails.merchantId
                              ].businessProfile.geoLoc,
                              agent.businessProfile.geoLoc,
                            ) /
                              1000 <=
                              this.state.deliveryAgentsRange,
                        ).length > 0 ? (
                          <table className="sticky">
                            <thead>
                              <tr>
                                <th className="label-cell">Assign</th>

                                <th className="label-cell">
                                  Distance From Merchant
                                </th>

                                <th className="input-cell">
                                  <span className="table-head-label">
                                    Vendor Name
                                  </span>
                                  <div className="input">
                                    <input
                                      type="text"
                                      value={this.state.deliveryAgentName}
                                      onChange={(e) =>
                                        this.setState({
                                          ...this.state,
                                          deliveryAgentName: e.target.value,
                                          deliveryAgentEmail: "",
                                          filterBy: {
                                            dbName: "vendors",
                                            property: "name",
                                            value: e.target.value,
                                            type: "text",
                                          },
                                        })
                                      }
                                      placeholder="Filter"
                                    />
                                  </div>
                                </th>

                                <th className="input-cell">
                                  <span className="table-head-label">
                                    Vendor Email
                                  </span>
                                  <div className="input">
                                    <input
                                      type="email"
                                      value={this.state.deliveryAgentEmail}
                                      onChange={(e) =>
                                        this.setState({
                                          ...this.state,
                                          deliveryAgentName: "",
                                          deliveryAgentEmail: e.target.value,
                                          filterBy: {
                                            dbName: "vendors",
                                            property: "email",
                                            value: e.target.value,
                                            type: "text",
                                          },
                                        })
                                      }
                                      placeholder="Filter"
                                    />
                                  </div>
                                </th>

                                <th className="label-cell">Vendor Phone</th>

                                <th className="label-cell">Vendor Address</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.deliveryAgents
                                .filter(
                                  (agent) =>
                                    agent.currentStatus === "online" &&
                                    agent.accountStatus === "Approved" &&
                                    getDistance(
                                      this.props.data.merchants[
                                        this.state.salesOrderDetails.merchantId
                                      ].businessProfile.geoLoc,
                                      agent.businessProfile.geoLoc,
                                    ) /
                                      1000 <=
                                      this.state.deliveryAgentsRange,
                                )
                                .concat(this.state.nearestBranches)
                                .sort(
                                  (a, b) =>
                                    getDistance(
                                      this.props.data.merchants[
                                        this.state.salesOrderDetails.merchantId
                                      ].businessProfile.geoLoc,
                                      a.businessProfile?.geoLoc || a.geoLoc,
                                    ) /
                                      1000 -
                                    getDistance(
                                      this.props.data.merchants[
                                        this.state.salesOrderDetails.merchantId
                                      ].businessProfile.geoLoc,
                                      b.businessProfile?.geoLoc || b.geoLoc,
                                    ) /
                                      1000,
                                )
                                .map((agent) => (
                                  <tr key={agent.id}>
                                    <td>
                                      <Button
                                        fill
                                        className="button-fill-blue"
                                        onClick={() =>
                                          this.assignDeliveryAgent(
                                            this.state.salesOrderDetails.id,
                                            agent.id,
                                          )
                                        }
                                      >
                                        Assign
                                      </Button>
                                    </td>
                                    <td>
                                      <div>
                                        {(
                                          getDistance(
                                            this.props.data.merchants[
                                              this.state.salesOrderDetails
                                                .merchantId
                                            ].businessProfile.geoLoc,
                                            agent.businessProfile?.geoLoc ||
                                              agent?.geoLoc,
                                          ) / 1000
                                        ).toFixed(2) + "km away"}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {agent.businessProfile?.name ||
                                          `${agent.headquatersName} - ${agent.name}`}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {agent.businessProfile?.email ||
                                          this.props.data.delivery[agent.HQId]
                                            ?.businessProfile?.email}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {agent.businessProfile?.phone ||
                                          agent?.phone}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {agent.businessProfile?.address ||
                                          agent?.address}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        ) : (
                          <Block className="block-info">
                            <Row>
                              <Col>
                                <p>
                                  No Available delivery agent within{" "}
                                  {this.state.deliveryAgentsRange} km range of
                                  this merchant's location
                                </p>
                              </Col>
                            </Row>
                          </Block>
                        )}
                      </CardContent>
                    </Card>
                  </div>
                ) : null}
              </Block>
            ) : null}
          </Page>
        </Popup>
      </Page>
    );
  }

  //   Lifecycle
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.filterBy.dbName.trim() === "") {
      return {
        orders:
          (nextProps.ordered &&
            nextProps.ordered.orders &&
            nextProps.ordered.orders.filter(
              ({ merchantId, assignedAgentId }) => {
                if (
                  nextProps.profile &&
                  nextProps.profile.assignedVendors &&
                  nextProps.profile.assignedVendors.length > 0 &&
                  nextProps.profile.assignedVendors.find((v) => {
                    if (
                      (v.id === merchantId && v.type === "Merchant") ||
                      (v.id === assignedAgentId && v.type === "Delivery")
                    ) {
                      return true;
                    } else {
                      return false;
                    }
                  })
                ) {
                  return true;
                } else {
                  return false;
                }
              },
            )) ||
          [],
        deliveryAgents: (nextProps.ordered && nextProps.ordered.delivery) || [],
      };
    } else {
      let modifiedState = {
        orders: (nextProps.ordered && nextProps.ordered.orders) || [],
        deliveryAgents: (nextProps.ordered && nextProps.ordered.delivery) || [],
      };

      switch (prevState.filterBy.dbName) {
        case "orders":
          let filter;
          switch (prevState.filterBy.type) {
            case "text":
              filter = new FilterByText(
                modifiedState.orders.filter(
                  ({ merchantId, assignedAgentId }) => {
                    if (
                      nextProps.profile &&
                      nextProps.profile.assignedVendors &&
                      nextProps.profile.assignedVendors.length > 0 &&
                      nextProps.profile.assignedVendors.find((v) => {
                        if (
                          (v.id === merchantId && v.type === "Merchant") ||
                          (v.id === assignedAgentId && v.type === "Delivery")
                        ) {
                          return true;
                        } else {
                          return false;
                        }
                      })
                    ) {
                      return true;
                    } else {
                      return false;
                    }
                  },
                ),
              );
              return (modifiedState = {
                ...modifiedState,
                orders: filter.filter(prevState),
              });

            default:
          }
        case "vendors":
          switch (prevState.filterBy.type) {
            case "text":
              filter = new FilterByText(modifiedState.deliveryAgents);
              return (modifiedState = {
                ...modifiedState,
                deliveryAgents: filter.filter(prevState),
              });

            default:
          }

        default:
        // inbox
      }

      //   return modifiedState;
    }

    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.deliveryAgentsRange !== this.state.deliveryAgentsRange) {
      this.getNearestBranches();
    }
  }

  //   Events

  async getNearestBranches() {
    this.$f7.preloader.show();
    try {
      // Find cities within range

      const center = [
        this.props.data.merchants[this.state.salesOrderDetails.merchantId]
          .businessProfile.geoLoc.lat,
        this.props.data.merchants[this.state.salesOrderDetails.merchantId]
          .businessProfile.geoLoc.lng,
      ];
      const radiusInM = this.state.deliveryAgentsRange * 1000;

      // Each item in 'bounds' represents a startAt/endAt pair. We have to issue
      // a separate query for each pair. There can be up to 9 pairs of bounds
      // depending on overlap, but in most cases there are 4.
      const bounds = geofire.geohashQueryBounds(center, radiusInM);
      const promises = [];
      for (const b of bounds) {
        const q = this.props.firestore
          .collectionGroup("branches")
          .orderBy("geohash")
          .startAt(b[0])
          .endAt(b[1]);

        promises.push(q.get());
      }

      // Collect all the query results together into a single list
      Promise.all(promises).then((snapshots) => {
        const matchingDocs = [];

        for (const snap of snapshots) {
          for (const doc of snap.docs) {
            const lat = doc.get("geoLoc.lat");
            const lng = doc.get("geoLoc.lng");

            // We have to filter out a few false positives due to GeoHash
            // accuracy, but most will match
            const distanceInKm = geofire.distanceBetween([lat, lng], center);
            const distanceInM = distanceInKm * 1000;
            if (distanceInM <= radiusInM) {
              matchingDocs.push({
                HQId: doc.ref.parent.parent.id,
                id: doc.id,
                ...doc.data(),
              });
            }
          }
        }

        const formattedMatchingDocs = matchingDocs.filter(
          ({ HQId, suspended }) =>
            !suspended &&
            this.props.data?.delivery[HQId]?.accountStatus === "Approved",
        );

        this.setState({
          ...this.state,
          nearestBranches: formattedMatchingDocs,
        });
        this.$f7.preloader.hide();
      });
    } catch (error) {
      this.$f7.preloader.hide();
      console.log(error);
    }
  }

  declineOrderForDeliveryAgent(orderId, deliveryAgentName) {
    let self = this;
    let app = self.$f7;
    app.dialog
      .create({
        title: "Decline Order",
        cssClass: "otp-code-modal",
        text: `Are you sure u want to decline this order on behalf of ${deliveryAgentName} to be reassigned to another agent?`,
        destroyOnClose: true,
        buttons: [
          // button to close modal
          {
            text: "x",
            color: "white",
            cssClass: "otp-close",
          },
          // button to continue
          {
            text: "Yes",
            bold: true,
            cssClass: "otp-continue button button-fill-red",
            keyCodes: [13],
            close: false,
            onClick: (dialog, e) => {
              app.preloader.show();
              this.props.firestore
                .collection("orders")
                .doc(orderId)
                .update({
                  assignedAgentId: "",
                  agent: {},
                  triggeredBy: this.props.auth.uid,
                  orderStatus: "Order Pending",
                  assignedByAdminOrSupport: null,
                  deliveryDeclinedByAdminOrSupport: {
                    name: this.props.profile.fullName,
                    email: this.props.profile.email,
                    role: this.props.profile.role,
                    phone: this.props.profile.phoneNumber,
                    timestamp: Date.now(),
                    deliveryAgentName,
                  },
                })
                .then(() => {
                  this.setState({
                    ...this.state,
                    vendorSheetOpened: false,
                    deliveryAgentName: "",
                    deliveryAgentEmail: "",
                  });
                  app.preloader.hide();

                  toast(app.toast, {
                    text: "Order delivery declined",
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  dialog.close();
                })
                .catch((error) => {
                  this.setState({
                    ...this.state,
                    vendorSheetOpened: false,
                    deliveryAgentName: "",
                    deliveryAgentEmail: "",
                  });
                  this.$f7.preloader.hide();
                  toast(app.toast, {
                    text: handleErrors(error),
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  dialog.close();
                });
            },
          },
        ],
      })
      .open();
  }

  assignDeliveryAgent(orderId, assignedAgentId) {
    const self = this;
    const app = self.$f7;

    app.dialog
      .create({
        title: "Assign Delivery Agent",
        cssClass: "otp-code-modal",
        text: `Assign Order: ${orderId} to delivery agent ${
          this.props.data.delivery[assignedAgentId]?.businessProfile.name ||
          this.state.nearestBranches.find(({ id }) => id === assignedAgentId)
            .name
        }`,
        destroyOnClose: true,
        buttons: [
          // button to close modal
          {
            text: "x",
            color: "white",
            cssClass: "otp-close",
          },
          // button to continue
          {
            text: "Assign",
            bold: true,
            cssClass: "otp-continue button button-fill-red",
            keyCodes: [13],
            close: false,
            onClick: (dialog, e) => {
              app.preloader.show();
              const branch = this.state.nearestBranches.find(
                ({ id }) => id === assignedAgentId,
              );

              assignedAgentId = branch ? branch.HQId : assignedAgentId;

              const isBranch = branch ? true : false;

              const agent = {
                name: this.props.data.delivery[assignedAgentId].businessProfile
                  .name,
                address:
                  this.props.data.delivery[assignedAgentId].businessProfile
                    .address,
                phone:
                  this.props.data.delivery[assignedAgentId].businessProfile
                    .phone,
                branch: isBranch
                  ? {
                      id: branch.id,
                      name: branch.name,
                      address: branch.address,
                      phone: branch.phone,
                    }
                  : null,
              };

              this.props.firestore
                .collection("orders")
                .doc(orderId)
                .update({
                  assignedAgentId,
                  agent,
                  orderStatus: "Order Pending Delivery",
                  assignedByAdminOrSupport: {
                    name: this.props.profile.fullName,
                    email: this.props.profile.email,
                    role: this.props.profile.role,
                    phone: this.props.profile.phoneNumber,
                    timestamp: Date.now(),
                  },
                })
                .then(() => {
                  this.setState({
                    ...this.state,
                    vendorSheetOpened: false,
                    deliveryAgentName: "",
                    deliveryAgentEmail: "",
                    nearestBranches: [],
                    vendorSheetOpened: false,
                    deliveryAgentName: "",
                    deliveryAgentEmail: "",
                  });
                  app.preloader.hide();

                  toast(app.toast, {
                    text: "Order has been assigned",
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  dialog.close();
                })
                .catch((error) => {
                  this.setState({
                    ...this.state,
                    vendorSheetOpened: false,
                    deliveryAgentName: "",
                    deliveryAgentEmail: "",
                    nearestBranches: [],
                    vendorSheetOpened: false,
                    deliveryAgentName: "",
                    deliveryAgentEmail: "",
                  });
                  app.preloader.hide();
                  toast(app.toast, {
                    text: handleErrors(error),
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  dialog.close();
                });
            },
          },
        ],
      })
      .open();
  }

  confirmOrder(orderId, confirmationCode) {
    this.$f7.dialog
      .create({
        title: "Confirmation Code",
        cssClass: "otp-code-modal",
        text: "Please enter order cofirmation code to confirm this order.",
        content: `<input class="dialog-input single-input" type="text" maxlength="6"/>`,
        destroyOnClose: true,
        buttons: [
          // button to cancel
          {
            text: "x",
            color: "white",
            cssClass: "otp-close",
          },
          // button to continue
          {
            text: "Confirm Order",
            bold: true,
            cssClass: "otp-continue",
            keyCodes: [13],
            close: false,
            onClick: (dialog, e) => {
              this.$f7.preloader.show();
              if (confirmationCode.trim() === "") {
                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: "Please enter the confirmation code for this order",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              }

              const inputedCode = dialog.$el.find(".dialog-input").val();
              if (confirmationCode === inputedCode) {
                // send confirmation mail
                dialog.close();
                this.$f7.preloader.show();
                // send otp mail
                this.props.firebase
                  .auth()
                  .currentUser.getIdToken(true)
                  .then((idToken) => {
                    // send OTP to Easychaw's email
                    sendEasychawOneTimePassword(
                      {
                        token: idToken,
                        uid: this.props.auth.uid,
                        actions: "Confirmation",
                      },
                      (error, sent) => {
                        if (error || !sent) {
                          this.$f7.preloader.hide();
                          return toast(this.$f7.toast, {
                            text: error,
                            position: "bottom",
                            horizontalPosition: "center",
                            closeButton: true,
                            cssClass: "custom-toast",
                            closeTimeout: 4000,
                          });
                        }

                        // open a dialog to confirm OTP
                        this.$f7.preloader.hide();
                        this.$f7.dialog
                          .create({
                            title: "OTP CODE",
                            cssClass: "otp-code-modal",
                            text: "Confirm changes by filling in the OTP code sent to Easychaw's email address",
                            content: `<input class="dialog-input split-input" type="password" maxlength="4" />`,
                            buttons: [
                              // button to resend otp
                              {
                                text: "Resend Code",
                                color: "gray",
                                cssClass: "otp-resend",

                                close: false,
                                onClick: (dialog, e) => {
                                  this.$f7.preloader.show();
                                  sendEasychawOneTimePassword(
                                    {
                                      token: idToken,
                                      uid: this.props.auth.uid,
                                      actions: "Confirmation",
                                    },
                                    (error, sent) => {
                                      if (error || !sent) {
                                        this.$f7.preloader.hide();
                                        return toast(this.$f7.toast, {
                                          text: error,
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                      }

                                      this.$f7.preloader.hide();
                                      return toast(this.$f7.toast, {
                                        text: "OTP code sent",
                                        position: "bottom",
                                        horizontalPosition: "center",
                                        closeButton: true,
                                        cssClass: "custom-toast",
                                        closeTimeout: 4000,
                                      });
                                    },
                                  );
                                },
                              },
                              // button to cancel
                              {
                                text: "x",
                                color: "white",
                                cssClass: "otp-close",
                                onClick: (dialog, e) => {
                                  this.$f7.preloader.hide();
                                },
                              },
                              // button to continue
                              {
                                text: "Continue",
                                bold: true,
                                cssClass: "otp-continue",
                                keyCodes: [13],
                                close: false,
                                onClick: (cdialog, e) => {
                                  this.$f7.preloader.show();
                                  // password
                                  const password = cdialog.$el
                                    .find(".dialog-input")
                                    .val();

                                  // Verify otp
                                  verifyEasychawOneTimePassword(
                                    {
                                      password,
                                      token: idToken,
                                      uid: this.props.auth.uid,
                                    },
                                    (error, success) => {
                                      if (error || !success) {
                                        this.$f7.preloader.hide();
                                        return toast(this.$f7.toast, {
                                          text: error,
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                      }

                                      // close dialog
                                      cdialog.close();

                                      this.props.firestore
                                        .collection("orders")
                                        .doc(orderId)
                                        .update({
                                          orderStatus: "Order Completed",
                                          completed: true,
                                          triggeredBy: this.props.auth.uid,
                                          confirmedByAdminOrSupport: {
                                            name: this.props.profile.fullName,
                                            email: this.props.profile.email,
                                            role: this.props.profile.role,
                                            phone:
                                              this.props.profile.phoneNumber,
                                            timestamp: Date.now(),
                                          },
                                        })
                                        .then(() => {
                                          this.$f7.preloader.hide();
                                          toast(this.$f7.toast, {
                                            text: "Order Confirmed",
                                            position: "bottom",
                                            horizontalPosition: "center",
                                            closeButton: true,
                                            cssClass: "custom-toast",
                                            closeTimeout: 4000,
                                          });
                                        })
                                        .catch((error) => {
                                          this.$f7.preloader.hide();
                                          toast(this.$f7.toast, {
                                            text: handleErrors(error),
                                            position: "bottom",
                                            horizontalPosition: "center",
                                            closeButton: true,
                                            cssClass: "custom-toast",
                                            closeTimeout: 4000,
                                          });
                                        });
                                    },
                                  );
                                },
                              },
                            ],
                          })
                          .open();
                      },
                    );
                  })
                  .catch((error) => {
                    this.$f7.preloader.hide();
                    return toast(this.$f7.toast, {
                      text: handleErrors(error),
                      position: "bottom",
                      horizontalPosition: "center",
                      closeButton: true,
                      cssClass: "custom-toast",
                      closeTimeout: 4000,
                    });
                  });
              } else {
                this.$f7.preloader.hide();
                toast(this.$f7.toast, {
                  text: "Delivery not confirmed",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
                dialog.close();
              }
            },
          },
        ],
      })
      .open();
  }

  declineOrder(orderId) {
    const self = this;
    const app = self.$f7;

    app.dialog
      .create({
        title: "Decline Order",
        cssClass: "otp-code-modal",
        text: "This action is irreversible, order will be cancelled and funds returned to user wallet",
        destroyOnClose: true,
        buttons: [
          // button to close modal
          {
            text: "x",
            color: "white",
            cssClass: "otp-close",
          },
          // button to continue
          {
            text: "Decline Order",
            bold: true,
            cssClass: "otp-continue button button-fill-red",
            keyCodes: [13],
            close: false,
            onClick: (dialog, e) => {
              app.preloader.show();
              // Update order status
              this.props.firestore
                .collection("orders")
                .doc(orderId)
                .update({
                  orderStatus: "Order Cancelled",
                  cancelledByAdminOrSupport: {
                    name: this.props.profile.fullName,
                    email: this.props.profile.email,
                    role: this.props.profile.role,
                    phone: this.props.profile.phoneNumber,
                    timestamp: Date.now(),
                  },
                })
                .then(() => {
                  app.preloader.hide();
                  toast(this.$f7.toast, {
                    text: "Order Cancelled",
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  dialog.close();
                })
                .catch((error) => {
                  app.preloader.hide();
                  toast(app.toast, {
                    text: handleErrors(error),
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  dialog.close();
                });
            },
          },
        ],
      })
      .open();
  }
}

const mapStateToProps = ({
  firebase: { auth, profile },
  DB: { data, ordered },
}) => ({
  auth,
  profile,
  data,
  ordered,
});

const enhance = compose(
  withFirestore,
  firestoreConnect([
    new Collections("merchants"),
    new Collections("delivery"),
    new Collections("orders"),
  ]),
  connect(mapStateToProps),
);

export default enhance(Support);
